module.exports = __webpack_public_path__ + "img/craftBannerSatelliteBroker.0ea8cce.webp";